<template>
    <div>

    </div>
</template>

<script>
export default {
    mounted() {
        console.log(this.$route?.query)
        this.getUserStep()
    },
    methods: {
        async nextStep(data) {
            const step = data?.key
            const code = this.$route?.query?.code;
            const token = this.$route?.query?.token;
            const query = code
                ? `?code=${code}&auth=true${token ? `&token=${token}` : ''}`
                : `?${token ? `&token=${token}` : ''}`;

            const querySetPasword =  `?code=${'******'}&auth=true${token ? `&token=${token}` : ''}`;

            switch (step) {
                case "verify_email":
                    // await this.resendVerificationCode()
                    await this.$_resendSignUpOtpCode({ userId: data?.userId || data?.user_id })
                    this.generateToast("Welcome back, Onboarding in progress", "success");
                    this.$router.push(`/signup/authentication${query}`);
                    break;


                case "set_password":
                    // await this.resendVerificationCode()
                    await this.$_resendSignUpOtpCode({ userId: data?.userId || data?.user_id })
                    this.generateToast("Welcome back, Onboarding in progress", "success");
                    this.$router.push(`/signup/authentication${querySetPasword}`);
                    break;


                case "signup":
                    this.generateToast(data?.message);
                    this.$router.push(`/signup`);
                    break;

                case "org_details":
                    this.generateToast("Welcome back, Onboarding in progress", "success");
                    this.$router.push(`/onboarding/account-owner`);
                    break;


                default:
                    this.handleSuccessfulUserSignup(data)
                    break;
            }
        },
        handleSuccessfulUserSignup(data) {
            this.loading = false;
            this.generateToast(data?.message, "success");
            this.$router.push(`/signup`);
        },
        async resendVerificationCode() {
            if (!this.$route?.query?.userId) return;
            this.generateToast("Resending...", "success");
            const userId = this.$route?.query?.userId;
            const email = this.userResponse?.email

            try {
                let response = await this.$_resendSignUpOtpCode({ userId, email });
                console.log("response", response)
                this.generateToast("Verification code sent to your email", "success");
            } catch (error) {
                this.handleError(error);
            }
        },
        async getUserStep() {
            const userRes = await this.$_signedupUser({ userId: this.$route?.query?.userId });
            this.userResponse = userRes
            this.nextStep(userRes?.data?.data)
        }
    },
}
</script>

<style lang="scss" scoped></style>